import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaUser, FaLock, FaArrowRight, FaStore, FaCar } from 'react-icons/fa';

export default function Login({ setUser }) {
    const [usuario, setInputUsuario] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!usuario || !password) {
            Swal.fire({ icon: 'warning', title: 'Campos incompletos', text: 'Por favor ingrese usuario y contraseña', confirmButtonColor: '#667eea' });
            return;
        }
        setLoading(true);
        try {
            const response = await axios.post('https://api.alquilacarbolivia.com/api/login', { usuario, password });
            const userData = response.data;

            localStorage.setItem('user', JSON.stringify(userData));
            setUser(userData);

            await Swal.fire({
                icon: 'success',
                title: '¡Bienvenido!',
                text: `Hola ${userData.nombre}`,
                timer: 2000,
                showConfirmButton: false,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                iconColor: 'white'
            });

            // --- LÓGICA DE REDIRECCIÓN CORREGIDA ---
            if (userData.rol === 'admin') {
                navigate('/admin');
            } else {
                // SI ES SUCURSAL 4 (ALQUILACAR), IR AL DASHBOARD DE RENTAS
                if (parseInt(userData.sucursal_id) === 4) {
                    navigate('/alquilacar');
                } else {
                    navigate(`/sucursal/${userData.sucursal_id}`);
                }
            }

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Acceso Denegado',
                text: error.response?.data?.message || 'Error al conectar con el servidor',
                confirmButtonColor: '#ee0979'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center p-3" style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            position: 'relative', overflow: 'hidden'
        }}>
            <div className="card border-0 shadow-lg" style={{ width: '100%', maxWidth: '450px', borderRadius: '25px', background: 'rgba(255,255,255,0.95)', backdropFilter: 'blur(10px)' }}>
                <div className="card-body p-5">
                    <div className="text-center mb-4">
                        <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style={{ width: '80px', height: '80px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
                            <FaStore size={40} />
                        </div>
                        <h3 className="fw-bold" style={{ color: '#2d3748' }}>CONTROL-REST</h3>
                        <p className="text-muted">Ingresa tus credenciales</p>
                    </div>

                    <form onSubmit={handleLogin}>
                        <div className="mb-4">
                            <label className="form-label fw-bold small">Usuario</label>
                            <div className="position-relative">
                                <FaUser className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" />
                                <input type="text" className="form-control ps-5 py-3" placeholder="Tu usuario" value={usuario} onChange={(e) => setInputUsuario(e.target.value)} style={{ borderRadius: '15px' }} />
                            </div>
                        </div>
                        <div className="mb-4">
                            <label className="form-label fw-bold small">Contraseña</label>
                            <div className="position-relative">
                                <FaLock className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted" />
                                <input type="password" className="form-control ps-5 py-3" placeholder="••••••••" value={password} onChange={(e) => setPassword(e.target.value)} style={{ borderRadius: '15px' }} />
                            </div>
                        </div>
                        <button type="submit" className="btn btn-primary w-100 py-3 fw-bold shadow-lg" disabled={loading} style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', border: 'none', borderRadius: '15px' }}>
                            {loading ? 'Verificando...' : <>INGRESAR <FaArrowRight className="ms-2" /></>}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}